/**
 * Skeleton loaders for homepage sections while content loads
 */
import React from 'react';

export const CardSkeleton = ({ className = '' }) => (
  <div className={`bg-gray-800/50 rounded-xl animate-pulse ${className}`}>
    <div className="aspect-[3/4] bg-gray-700/50 rounded-t-xl"></div>
    <div className="p-3 space-y-2">
      <div className="h-4 bg-gray-700/50 rounded w-3/4"></div>
      <div className="h-3 bg-gray-700/50 rounded w-1/2"></div>
    </div>
  </div>
);

export const DropSkeleton = () => (
  <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
    {[1, 2, 3].map(i => (
      <CardSkeleton key={i} className="min-w-[160px] w-[160px]" />
    ))}
  </div>
);

export const SectionSkeleton = ({ title }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between mb-4">
      <div className="h-6 bg-gray-700/50 rounded w-32 animate-pulse"></div>
      <div className="h-4 bg-gray-700/50 rounded w-16 animate-pulse"></div>
    </div>
    <DropSkeleton />
  </div>
);
